import Vue from "vue";
import "xe-utils";
import "umy-ui/lib/theme-chalk/index.css"; // 引入样式
import App from "./App.vue";
import router from "./router/index";
import axios from "axios";
import ElementUI from "element-ui";
import store from "@/store";
import filters from "@/utils/filters";
import i18n from "./components/common/i18n/index";
import directives from "@/directives";
import Cookies from "js-cookie";
import actionCheck from "@/components/common/actionCheck";
import { UTable, UTableColumn, UxGrid, UxTableColumn } from "umy-ui";
import "@/assets/icon/iconfont.css";
import echarts from "echarts";
import { saveAs } from "file-saver";
import Common from "./components/common/common";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

import VueVirtualScroller from "vue-virtual-scroller";
import { RecycleScroller } from "vue-virtual-scroller";
//import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import '../static/css/theme-green/index.css';       // 浅绿色主题
// import './components/common/directives';
import "babel-polyfill";
import "font-awesome/scss/font-awesome.scss";
import "@/theme/index.css"; //黄色的主题颜色
import "@/theme/fonts.css";
//引入JS
import pagingUtils from "./components/common/pagingUtils";
import { getToken, login } from "@/api/login";
import { setUser } from "@/store/main";
import commonFun from "@/utils/commonFun";
import Message from "./components/common/myMessage";
import resetMessage from "./components/common/resetMessage";
import versionTood from './utils/systemUpdate'
Vue.prototype.$echarts = echarts;
Vue.prototype.utils = Common;
//Vue自定义函数挂到全局方法
Vue.use(VueVirtualScroller);
Vue.component("RecycleScroller", RecycleScroller);
Vue.use(pagingUtils);
Vue.prototype.actionCheck = actionCheck;
Vue.prototype.commonFun = commonFun;
Vue.config.productionTip = false;
Vue.use(UTable);
Vue.use(UTableColumn);
Vue.use(UxGrid);
Vue.use(UxTableColumn);
Vue.use(ElementUI, {
    size: "small",
});
Vue.prototype.$my_message = Message.install;
Vue.prototype.$msg = resetMessage;
Vue.prototype.$axios = axios;
Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key]);
});
Object.keys(directives).forEach((key) => {
    Vue.directive(key, directives[key]);
});

function authenticate(logincookie, next) {
    login(logincookie)
        .then((res) => {
            // console.log('菜单',this.$store);
            Cookies.remove("LOGIN_COOKIE");
            let user = res.data.user;
            //let token ='Bearer '+ user.id_token;
            localStorage.setItem("ms_username", user.name);
            localStorage.setItem("ms_userCd", user.userCd);
            localStorage.setItem("ms_userId", user.tmUserId);
            localStorage.setItem("groupableSupplier", user.groupableSupplier);
            store.commit(setUser, user);
            //将用户标识存入localStorage 用于区划是SGM员工(SGM)还是供应商人员(SUP)
            localStorage.setItem("ms_emplFlag", user.emplFlag);
            //将用户角色存入localStorage
            localStorage.setItem("ms_roles", JSON.stringify(user.roleCodes));
            //将用户权限存入localStorage
            localStorage.setItem("ms_Permission", JSON.stringify(user.funCodes));
            localStorage.setItem("ms_DataScope", JSON.stringify(user.dataScope));
            //国际化语言
            if (!!user.userWorkLanguage &&
                (user.userWorkLanguage == "en_US" || user.userWorkLanguage == "en-US")
            ) {
                i18n.locale = "en-US";
                localStorage.setItem("userWorkLanguage", "en-US");
            } else {
                i18n.locale = "zh-CN";
                localStorage.setItem("userWorkLanguage", "zh-CN");
            }
            localStorage.setItem("emplid", user.emplid);
            if (user.supplier) {
                localStorage.setItem("supplierObj", JSON.stringify(user.supplier));
            } else {
                localStorage.removeItem("supplierObj");
            }
            next();
        })
        .catch((reason) => {
            console.log("GY🚀 ~ file: main.js:115 ~ authenticate ~ reason:", reason);
            // alert(reason);
            window.location.href = process.env.VUE_APP_SERVER_LOGIN_URL;
        });
}
//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    console.log("GY🚀 ~ file: main.js:122 ~ router.beforeEach ~ to:", to);
    console.log('window.location.href', window.location.href)
    versionTood.isNewVersion();
    // "/ssologin",
    let whiteList = ["/login", "/splogin", "/common-audit", "/gallery", "/ssologin"];
    let rNext = next;
    if (to.path === "/mydashboard") {
        rNext = function() {
            let ms_Permission = JSON.parse(
                localStorage.getItem("ms_Permission") || "[]"
            );
            console.log("ms_Permission", ms_Permission);
            if (ms_Permission.indexOf("Dashboard") !== -1) {
                next();
            } else {
                if (ms_Permission.indexOf("ToDoList") !== -1) {
                    next({ path: "/mytask" });
                    console.log("main.js-有ToDoList-进入/mytask");
                } else if (
                    ms_Permission.indexOf("ToDoList") === -1 &&
                    ms_Permission.indexOf("QSPI_TODO_QUERY") !== -1
                ) {
                    next({ path: "/qspiTodo" });
                    console.log("main.js-有QSPI_TODO_QUERY-进入/qspiTodo");
                } else if (
                    ms_Permission.indexOf("ToDoList") === -1 &&
                    ms_Permission.indexOf("0120") !== -1
                ) {
                    next({ path: "/nutritionTodo" });
                    console.log("main.js-有QSPI_TODO_QUERY-进入/nutritionTodo");
                } else {
                    next({ path: "/mytask" });
                    console.log("main.js-无-进入/mytask");
                }
            }
        };
    }
    let logincookie = Cookies.get("LOGIN_COOKIE");
    console.log("window.location.href.split(' = ')[1]", decodeURIComponent(window.location.href.split('=')[1]))
    if (commonFun.isNotEmpty(logincookie)) {
        console.log('LOGIN_COOKIE存在,则需要自动登录authenticate')
        authenticate(logincookie, rNext);
    } else {
        console.log('LOGIN_COOKIE不存在')
        const role = localStorage.getItem("ms_userCd");
        console.log("GY🚀 ~ file: main.js:175 ~ router.beforeEach ~ role:", role);
        if (!role && !(whiteList.indexOf(to.path) >= 0)) {
            let logincookie = Cookies.get("LOGIN_COOKIE");
            if (commonFun.isEmpty(logincookie)) {
                console.log('LOGIN_COOKIE不存在且ms_userCd没值且白名单没有当前路径,如果是qa则到login页面,否则到ssologin页面')
                if (process.env.NODE_ENV === "dev") {
                    rNext("/login");
                } else {
                    window.location.href = process.env.VUE_APP_SERVER_LOGIN_URL;
                }
            } else {
                authenticate(logincookie, rNext);
            }
        } else if (to.meta.permission) {
            console.log('如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已')
            role === "admin" ? rNext() : rNext("/403");
        } else {
            console.log('LOGIN_COOKIE没有值,ms_userCd有值或者白名单存在当前路径')
            if (role && to.path == '/ssologin' && window.location.href.split('=')[1]) {
                console.log('如果当前路径是在ssologin页面,且ms_userCd有值且target有值,则直接跳转到target路径页面')
                var path = decodeURIComponent(window.location.href.split('=')[1]).split('#')[1]
                console.log("GY🚀 ~ file: main.js:193 ~ router.beforeEach ~ path:", path);
                rNext(path)
            } else {
                console.log('LOGIN_COOKIE没有值,ms_userCd有值或者白名单存在当前路径,则根据登录返回的菜单进入页面')
                rNext();
            }
        }
    }
});

Vue.directive("preventReClick", {
    inserted(el, binding) {
        el.addEventListener("click", () => {
            if (!el.disabled) {
                el.disabled = true;
                setTimeout(() => {
                    el.disabled = false;
                }, binding.value || 3000);
            }
        });
    },
});

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount("#app");